import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DataEndpoint } from '@core/models/general.model';
import { Observable, map } from 'rxjs';
import { BusinessDetailModel, BusinessGroupedModel, BusinessPaginatedModel, BusinessPaginatedRequestModel } from '../models/business.model';
import { HttpUtils } from '@core/utils/http.utils';

@Injectable({
  providedIn: 'root',
})
export class BusinessApi {
  private readonly http = inject(HttpClient);
  private readonly BUSINESS = '/Business';

  getBusinessGrouped(): Observable<DataEndpoint<BusinessGroupedModel[]>> {
    const url = `${this.BUSINESS}/grouped`;
    return this.http.get<DataEndpoint<BusinessGroupedModel[]>>(url)
      .pipe(map((data: DataEndpoint<BusinessGroupedModel[]>) => {
        return {...data}
      })); 
  }

  getBusinessList(request: BusinessPaginatedRequestModel): Observable<DataEndpoint<BusinessPaginatedModel>> {
    const url = this.BUSINESS;
    const params = HttpUtils.objectToHttpParams(request);
    
    return this.http.get<DataEndpoint<BusinessPaginatedModel>>(url, { params })
      .pipe(map((data: DataEndpoint<BusinessPaginatedModel>) => {
        return {...data}
      })); 
  }

  getBusinessDetail(id: string): Observable<DataEndpoint<BusinessDetailModel>> {
    const url = `${this.BUSINESS}/${id}`;
    
    return this.http.get<DataEndpoint<BusinessDetailModel>>(url)
      .pipe(map((data: DataEndpoint<BusinessDetailModel>) => {
        return {...data}
      })); 
  }

  postBusiness(request: FormData): Observable<DataEndpoint<any>> {
    const url = this.BUSINESS;
    
    return this.http.post<DataEndpoint<any>>(url, request)
      .pipe(map((data: DataEndpoint<any>) => {
        return {...data}
      })); 
  }

  updateBusiness(id: string, request: FormData): Observable<DataEndpoint<any>> {
    const url = `${this.BUSINESS}/${id}`;
    
    return this.http.put<DataEndpoint<any>>(url, request)
      .pipe(map((data: DataEndpoint<any>) => {
        return {...data}
      })); 
  }

  updateBusinessStatus(id: string): Observable<DataEndpoint<any>> {
    const url = `${this.BUSINESS}/${id}/status`;
    
    return this.http.patch<DataEndpoint<any>>(url, {})
      .pipe(map((data: DataEndpoint<any>) => {
        return {...data}
      })); 
  }
}